import axios from 'axios'

const NUTRITIONIX = {
  "APP_ID": "2587bbd2",
  "API_KEY": "f5c4bae465ba13e75657038e3c9800be",
  "SCAN_URL": "https://trackapi.nutritionix.com/v2/search/item?upc=",
  "INSTANT_URL": "https://trackapi.nutritionix.com/v2/search/instant?query=",
  "SEARCH_URL": "https://trackapi.nutritionix.com/v2/search/item?nix_item_id=",
  "NATURAL_URL": "https://trackapi.nutritionix.com/v2/natural/nutrients"
}

export function lookupSearchData(userId, data) {
	const url = NUTRITIONIX.INSTANT_URL + encodeURIComponent(data.replace(/[\u2018\u2019]/g,"'"))
	const headers = {
		'x-app-id': NUTRITIONIX.APP_ID,
		'x-app-key': NUTRITIONIX.API_KEY,
		'x-remote-user-id': userId
	}
	return axios.get(url, { headers: headers })
}

export function lookupBrandItem(userId, nutritionixItemID) {
	const url = NUTRITIONIX.SEARCH_URL + nutritionixItemID
	const headers = {
		'x-app-id': NUTRITIONIX.APP_ID,
		'x-app-key': NUTRITIONIX.API_KEY,
		'x-remote-user-id': userId
	}
	return axios.get(url, { headers: headers })
}

export function lookupNaturalItem(userId, nutritionixItemName) {
	const url = NUTRITIONIX.NATURAL_URL
	const headers = {
		'x-app-id': NUTRITIONIX.APP_ID,
		'x-app-key': NUTRITIONIX.API_KEY,
		'x-remote-user-id': userId
	}
	return axios.post(url, { query: nutritionixItemName }, { headers: headers })
}
